/**
 * Gallery hover animations.
 *
 * @package globus
 * @since   1.0.0
 */

/**
 * Kick-off hover animations.
 *
 * @since 1.0.0
 */
// get application list.
const appLi = document.getElementsByClassName('gallery-nav-item');

// add /  remove active class on mouse over.
function initHoverAnimation() {
	const appMedia = document.getElementsByClassName('preview-media');
	for (let i = 0; i < appMedia.length; i++) {
		if (!this.classList.contains('number')) {
			appMedia[i].classList.remove('active');
		}
	}

	for (let i = 0; i < appLi.length; i++) {
		appLi[i].classList.remove('active');
	}
	this.classList.add('active');

	if (!this.classList.contains('number')) {
		const dataId = this.getAttribute('data-id');
		const targetEl = document.getElementById(dataId);
		if (targetEl) {
			targetEl.classList.add('active');
		}
	}
}

// add mouseover event.
for (let i = 0; i < appLi.length; i++) {
	appLi[i].addEventListener('mouseover', initHoverAnimation);
	appLi[i].addEventListener('touchstart', initHoverAnimation);
}
